var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsoxLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2021,
    height: 352,
    viewBox: "0 0 2021 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.035 -2.38419e-05V50.25H614.535C572.535 50.25 564.785 57.75 564.785 99.25C564.785 140.75 572.535 148.25 614.535 148.25H854.035C920.785 148.25 948.035 175.5 948.035 242.5V255.75C948.035 322.75 920.785 350 854.035 350H506.535V299.75H843.285C885.535 299.75 893.035 292.25 893.035 250V248.25C893.035 206 885.535 198.5 843.285 198.5H604.035C537.035 198.5 509.785 171.25 509.785 104.25V94.25C509.785 27.25 537.035 -2.38419e-05 604.035 -2.38419e-05H928.035ZM1429.17 -2.38419e-05C1496.17 -2.38419e-05 1523.42 27.25 1523.42 94.25V255.75C1523.42 322.75 1496.17 350 1429.17 350H1127.67C1060.67 350 1033.67 322.75 1033.67 255.75V94.25C1033.67 27.25 1060.67 -2.38419e-05 1127.67 -2.38419e-05H1429.17ZM1088.67 250C1088.67 292.25 1096.17 299.75 1138.42 299.75H1418.67C1460.67 299.75 1468.42 292.25 1468.42 250V100C1468.42 57.75 1460.67 50.25 1418.67 50.25H1138.42C1096.17 50.25 1088.67 57.75 1088.67 100V250Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 150H2V200H147V150Z",
    fill: "#42BDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573 0V8L1739 158H1780V127L1639 0H1573Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021 0V8L1855 158H1814V127L1955 0H2021Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573 352V344L1739 194H1780V225L1639 352H1573Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021 352V344L1855 194H1814V225L1955 352H2021Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 51.2383V1H411.767V51.2383H1Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 350.238V300H411.767V350.238H1Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2021,
    height: 352,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsoxLogo);
export default __webpack_public_path__ + "static/media/esox-logo.21782dff3a371358f641dbbed9db177c.svg";
export { ForwardRef as ReactComponent };